<div class="layout" [ngClass]="{ 'show-frame': showFrame }">
  <scaffold-layout-header *ngIf="showFrame">
    <ng-content select="[layout-header]"></ng-content>
  </scaffold-layout-header>
  <scaffold-layout-sidebar [state]="leftSidebarState" side="left" *ngIf="showFrame" style="z-index: 1000;">
    <ng-content select="[layout-sidebar-left]"></ng-content>
  </scaffold-layout-sidebar>
  <div class="content" [ngClass]="{ 'left-collapsed': leftSidebarState === 'collapsed', 'left-open': leftSidebarState === 'compacted', 'right-open': rightSidebarState === 'compacted', 'left-open-full': leftSidebarState === 'expanded', 'right-open-full': rightSidebarState === 'expanded' }">
    <ng-content></ng-content>
  </div>
  <scaffold-layout-sidebar [state]="rightSidebarState" side="right" *ngIf="showFrame">
    <ng-content select="[layout-sidebar-right]"></ng-content>
  </scaffold-layout-sidebar>

</div>
